'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { TipSectionModel } from '../../types'

type Props = { props: TipSectionModel }

const TipSection = ({ props }: Props) => {
  const { text, testId } = props
  const translate = useTranslate()

  return (
    <section className="secondhand-taxes__tip-section" data-testid={testId}>
      <h3 className="secondhand-taxes__tip-section-title">{translate(text.title)}</h3>
      <p className="secondhand-taxes__tip-section-description">{translate(text.description)}</p>
    </section>
  )
}

export default TipSection
